import { HeaderContainer, HeaderContents } from '../style/Header.Styled';

export const SharedHeader = () => {
  return (
    <HeaderContainer>
      <HeaderContents>일간 박스오피스 Top 10 분석 서비스</HeaderContents>
    </HeaderContainer>
  );
};
